import client from './client'

// ── Types ────────────────────────────────────────────────────────────────────

export interface DashboardStats {
  timestamp: string
  current: {
    sessions: Array<{
      session_id: string
      worker_id: string
      state: string
      created_at: string
      room_name: string
      events_count: number
    }>
  }
  last_24h: { success_rate: number }
}

export interface WorkerInfo {
  worker_id: string
  session_id: string | null
  state: string
  language: string
  avatar_ready: boolean
  container_status: string
  age_seconds: number
  room_name: string | null
}

export interface DashboardWorkers {
  stats: {
    total_workers: number
    de_active: number
    en_active: number
    initializing_count: number
    de_ready_count: number
    en_ready_count: number
    active_sessions_count: number
  }
  workers: WorkerInfo[]
  docker_containers: Array<Record<string, unknown>>
}

export interface DashboardRedis {
  summary: {
    warm_workers: number
    active_workers: number
    ready_workers: number
    orphaned_worker_keys: number
    session_mappings: number
    active_sessions: number
  }
  worker_ready: Record<string, { value: string; ttl: number }>
  session_mappings: Record<string, { value: string; ttl: number }>
  tts_queues: Record<string, number>
  warm_pool: string[]
  active_workers: string[]
  warm_sessions: string[]
}

// ── API calls ────────────────────────────────────────────────────────────────

export async function getDashboardStats(): Promise<DashboardStats> {
  const { data } = await client.post('/admin/dashboard/stats', {})
  return data.result
}

export async function getDashboardWorkers(): Promise<DashboardWorkers> {
  const { data } = await client.post('/admin/dashboard/workers', {})
  return data.result
}

export async function getDashboardRedis(): Promise<DashboardRedis> {
  const { data } = await client.post('/admin/dashboard/redis', {})
  return data.result
}
